// src/components/Admin/AdminSettings.jsx
import React from 'react';
import AdminNavbar from './AdminNavbar';
import AdminSidebar from './AdminSidebar';

const AdminSettings = () => {
  return (
    <div className="min-h-screen bg-gray-100">
      <AdminNavbar />
      <div className="flex">
        <AdminSidebar />
        <main className="flex-1 p-6">
          <h1 className="text-2xl font-bold mb-6">System Settings</h1>
          <div className="bg-white p-6 rounded-lg shadow">
            <p className="text-gray-600">This is a demo settings page. You'll implement actual system settings here.</p>
          </div>
        </main>
      </div>
    </div>
  );
};

export default AdminSettings;